export const FETCH_CAMPAIGNS = 'CAMPAIGNS/FETCH_REQUEST';
export const FETCH_CAMPAIGNS_SUCCESS = 'CAMPAIGNS/FETCH_SUCCESS';

export const FETCH_CAMPAIGN = 'CAMPAIGN/FETCH_REQUEST';
export const FETCH_CAMPAIGN_SUCCESS = 'CAMPAIGN/FETCH_SUCCESS';

export const CREATE_CAMPAIGN = 'CAMPAIGN/POST_REQUEST';
export const CREATE_CAMPAIGN_SUCCESS = 'CAMPAIGN/POST_SUCCESS';

export const UPDATE_CAMPAIGN = 'CAMPAIGN/PUT_REQUEST';
export const UPDATE_CAMPAIGN_SUCCESS = 'CAMPAIGN/PUT_SUCCESS';

export const DUPLICATE_CAMPAIGN = 'CAMPAIGN/DUPLICATE_REQUEST';
export const DUPLICATE_CAMPAIGN_SUCCESS = 'CAMPAIGN/DUPLICATE_SUCCESS';

export const DELETE_CAMPAIGN = 'CAMPAIGN/DELETE_REQUEST';
export const DELETE_CAMPAIGN_SUCCESS = 'CAMPAIGN/DELETE_SUCCESS';
export const DELETE_CAMPAIGN_FAILURE = 'CAMPAIGN/DELETE_FAILURE';

export const PATCH_CAMPAIGN_STATUS = 'CAMPAIGN/PATCH_STATUS_REQUEST';
export const PATCH_CAMPAIGN_STATUS_SUCCESS = 'CAMPAIGN/PATCH_STATUS_SUCCESS';

export const PATCH_CAMPAIGN_NAME = 'CAMPAIGN/PATCH_NAME_REQUEST';
export const PATCH_CAMPAIGN_NAME_SUCCESS = 'CAMPAIGN/PATCH_NAME_SUCCESS';

export const DELETE_CAMPAIGN_SEND_DATE = 'CAMPAIGN/SEND_DATE/DELETE_REQUEST';
export const DELETE_CAMPAIGN_SEND_DATE_SUCCESS = 'CAMPAIGN/SEND_DATE/DELETE_SUCCESS';

export const PATCH_CAMPAIGN_SEND_DATE = 'CAMPAIGN/SEND_DATE/PATCH_REQUEST';
export const PATCH_CAMPAIGN_SEND_DATE_SUCCESS = 'CAMPAIGN/SEND_DATE/PATCH_SUCCESS';

export const SEND_CAMPAIGN = 'CAMPAIGN/SEND/POST_REQUEST';
export const SEND_CAMPAIGN_SUCCESS = 'CAMPAIGN/SEND/POST_SUCCESS';

export const OPEN_EXPORT = 'CAMPAIGN/EXPORT/OPEN';
export const CLOSE_EXPORT = 'CAMPAIGN/EXPORT/CLOSE';

export const EXPORT_CAMPAIGN = 'CAMPAIGN/EXPORT/POST_REQUEST';
export const EXPORT_CAMPAIGN_SUCCESS = 'CAMPAIGN/EXPORT/POST_SUCCESS';

/** FILTERS */
export const SET_CAMPAIGNS_DASHBOARD_FILTER = 'CAMPAIGNS/DASHBOARD/FILTERS/SET_ONE';
export const SET_CAMPAIGNS_DASHBOARD_FILTERS = 'CAMPAIGNS/DASHBOARD/FILTERS/SET_MANY';
export const REMOVE_CAMPAIGNS_DASHBOARD_FILTER = 'CAMPAIGNS/DASHBOARD/FILTERS/REMOVE_ONE';
export const CLEAR_CAMPAIGNS_DASHBOARD_FILTER = 'CAMPAIGNS/DASHBOARD/FILTERS/CLEAR';
export const PERSISTED_ACTION_TYPES = [
  SET_CAMPAIGNS_DASHBOARD_FILTER,
  SET_CAMPAIGNS_DASHBOARD_FILTERS,
  CLEAR_CAMPAIGNS_DASHBOARD_FILTER,
  REMOVE_CAMPAIGNS_DASHBOARD_FILTER,
];

export const OPEN_MODAL_CREATION = 'CAMPAIGNS/MODAL/CREATE/OPEN';
export const CLOSE_MODAL_CREATION = 'CAMPAIGNS/MODAL/CREATE/CLOSE';

export const OPEN_MODAL_DUPLICATE = 'CAMPAIGNS/MODAL/CLONE/OPEN';
export const CLOSE_MODAL_DUPLICATE = 'CAMPAIGNS/MODAL/CLONE/CLOSE';

export const DETAILS_INITIALIZED = 'CAMPAIGNS/DETAILS/INITIALIZED';

export const OPEN_SEND_MODAL = 'CAMPAIGNS/MODAL/SEND/OPEN';
export const CLOSE_SEND_MODAL = 'CAMPAIGNS/MODAL/SEND/CLOSE';
export const SEND_MODAL_READY = 'CAMPAIGNS/MODAL/SEND/READY';

export const OPEN_SEND_TEST_MODAL = 'CAMPAIGNS/MODAL/SEND/TEST/OPEN';
export const CLOSE_SEND_TEST_MODAL = 'CAMPAIGNS/MODAL/SEND/TEST/CLOSE';

export const OPEN_CONTENT_MODAL = 'CAMPAIGNS/MODAL/CONTENT/OPEN';
export const CLOSE_CONTENT_MODAL = 'CAMPAIGNS/MODAL/CONTENT/CLOSE';

export const IMPORT_CHECKLISTS_SUCCESS = 'CAMPAIGNS/IMPORT_CHECKLISTS_SUCCESS';
export const IMPORT_CHECKLISTS_FAILURE = 'CAMPAIGNS/IMPORT_CHECKLISTS_FAILURE';

export const FETCH_CAMPAIGN_PREVIEW = 'CAMPAIGNS/PREVIEW/FETCH_REQUEST';
export const FETCH_CAMPAIGN_PREVIEW_SUCCESS = 'CAMPAIGNS/PREVIEW/FETCH_SUCCESS';

export const FOLLOW_CAMPAIGN = 'CAMPAIGNS/FOLLOW_CAMPAIGN_FILES_REQUEST';
export const FOLLOW_CAMPAIGN_SUCCESS = 'CAMPAIGNS/FOLLOW_CAMPAIGN_FILES_SUCCESS';
export const UNFOLLOW_CAMPAIGN = 'CAMPAIGNS/UNFOLLOW_CAMPAIGN_FILES_REQUEST';
export const UNFOLLOW_CAMPAIGN_SUCCESS = 'CAMPAIGNS/UNFOLLOW_CAMPAIGN_FILES_SUCCESS';
